import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { LandCoverService } from '../proxy/planning/controllers/land-cover.service';

FieldBuilder.setNamespace('Planning');

export const SUBENVIRONMENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SubEnvironment.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SubEnvironment.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('landCoverId', 'Entity.LandCover', LandCoverService)
    .required()
    .displayFromNested('landCover.name')
    .sortBy('landCover.name')
    .build(),
];

export const SUBENVIRONMENT_CONFIG = {
  entityName: 'SubEnvironment',
  localizationKey: 'Planning::Entity.SubEnvironment',
  fields: SUBENVIRONMENT_FIELDS,
  permission: 'PlanningEnvironment.SubEnvironments',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
